// Make sure to register before importing any components
import "@/plugins/class-component-hooks";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTheMask from "vue-the-mask";
import VueAnimated from "@codekraft-studio/vue-animated";
import { VTextField } from "vuetify/lib"; // Globally import VTextField
import Vue2Filters from "vue2-filters";

Vue.use(VueAnimated);
Vue.use(VueTheMask);
Vue.use(Vue2Filters);

Vue.config.productionTip = false;
Vue.component("v-text-field", VTextField);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
